import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const tagsCrumb = {
  label: 'global.sidebar.tags_trans',
  route: { name: 's-tags' },
};

const tags_routes = [
  {
    path: 'tags',
    name: 'tags',
    meta: {
      permissions: 'read-tags',
    },
    children: [
      {
        path: '',
        name: 's-tags',
        component: () => import('@/views/System/Settings/Tags/TagsList.vue'),
        meta: {
          permissions: 'read-tags',
          breadcrumbs: settingsBreadcrumbs(tagsCrumb),
        },
      },
      {
        path: 'add',
        name: 's-tags-add',
        component: () => import('@/views/System/Settings/Tags/Components/TagForm.vue'),
        meta: {
          permissions: 'write-tags',
          breadcrumbs: settingsBreadcrumbs(tagsCrumb),
        },
      },
      {
        path: 'edit/:id',
        name: 's-tags-edit',
        component: () => import('@/views/System/Settings/Tags/Components/TagForm.vue'),
        meta: {
          permissions: 'update-tags',
          breadcrumbs: settingsBreadcrumbs(tagsCrumb),
        },
      },
    ],
  },
];

export default tags_routes;
